import { memo } from "react";
import * as Styled from "./style";

export type TagListData = {
  /** TagButtonに表示するテキスト */
  label: string;
  /** TagButton Click時に発火するイベントハンドラ */
  onTagButtonClicked: () => void;
};

export type TagListProps = {
  activeIndex: number;
  tagListArray: TagListData[];
  resetScrollPosition?: () => void;
};

/**
 * タグの一覧を並べるコンポーネント
 * @param props {@link TagListProps}
 */
export const TagList = memo(({ activeIndex, tagListArray, resetScrollPosition }: TagListProps) => {
  return (
    <Styled.SecTagListWrapper arrayLength={tagListArray.length}>
      {tagListArray.map(({ label, onTagButtonClicked }, idx) => {
        return (
          <Styled.ButtonTag
            key={label}
            type="button"
            aria-selected={activeIndex === idx}
            isSelected={activeIndex === idx}
            onClick={() => {
              onTagButtonClicked();
              if (resetScrollPosition) {
                resetScrollPosition();
              }
            }}
          >
            {label}
          </Styled.ButtonTag>
        );
      })}
    </Styled.SecTagListWrapper>
  );
});

TagList.displayName = "TagList";
